import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { PrivateRoute, AdminRoute } from '@/components/PrivateRoute';
import { Toaster } from '@/components/ui/sonner';
import ScreenLock from '@/components/ScreenLock';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Transactions from '@/pages/Transactions';
import Bills from '@/pages/Bills';
import BankAccounts from '@/pages/BankAccounts';
import Users from '@/pages/Users';
import Products from '@/pages/Products';
import Customers from '@/pages/Customers';
import Orders from '@/pages/Orders';
import Notifications from '@/pages/Notifications';
import Settings from '@/pages/Settings';
import NFe from '@/pages/NFe';
import Employees from '@/pages/Employees';
import EstoqueMadeira from '@/pages/EstoqueMadeira';
import DRE from '@/pages/DRE';
import Vendas from '@/pages/Vendas';
import VendasLogin from '@/pages/VendasLogin';
import Entregas from '@/pages/Entregas';
import Producao from '@/pages/Producao';
import OrdensServico from '@/pages/OrdensServico';
import Lembretes from '@/pages/Lembretes';
import SimuladorCartao from '@/pages/SimuladorCartao';
import CentralDashboard from '@/pages/central/CentralDashboard';
import CentralConversas from '@/pages/central/CentralConversas';
import CentralAguardando from '@/pages/central/CentralAguardando';
import CentralBaseConhecimento from '@/pages/central/CentralBaseConhecimento';
import CentralConfigIA from '@/pages/central/CentralConfigIA';
import CentralConfigWhatsApp from '@/pages/central/CentralConfigWhatsApp';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import '@/App.css';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScreenLock>
            <div className="App">
              <Routes>
              <Route path="/login" element={<Login />} />
              
              {/* Páginas públicas (sem autenticação) */}
              <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              
              {/* Módulo de Vendas - Acesso independente */}
              <Route path="/vendas/login" element={<VendasLogin />} />
              <Route path="/vendas" element={<Vendas />} />
              
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/transactions"
                element={
                  <PrivateRoute>
                    <Transactions />
                  </PrivateRoute>
                }
              />
              <Route
                path="/bills"
                element={
                  <PrivateRoute>
                    <Bills />
                  </PrivateRoute>
                }
              />
              <Route
                path="/bank-accounts"
                element={
                  <PrivateRoute>
                    <BankAccounts />
                  </PrivateRoute>
                }
              />
              <Route
                path="/products"
                element={
                  <PrivateRoute>
                    <Products />
                  </PrivateRoute>
                }
              />
              <Route
                path="/estoque-madeira"
                element={
                  <PrivateRoute>
                    <EstoqueMadeira />
                  </PrivateRoute>
                }
              />
              <Route
                path="/dre"
                element={
                  <PrivateRoute>
                    <DRE />
                  </PrivateRoute>
                }
              />
              <Route
                path="/producao"
                element={
                  <PrivateRoute>
                    <Producao />
                  </PrivateRoute>
                }
              />
              <Route
                path="/ordens-servico"
                element={
                  <PrivateRoute>
                    <OrdensServico />
                  </PrivateRoute>
                }
              />
              <Route
                path="/customers"
                element={
                  <PrivateRoute>
                    <Customers />
                  </PrivateRoute>
                }
              />
              <Route
                path="/orders"
                element={
                  <PrivateRoute>
                    <Orders />
                  </PrivateRoute>
                }
              />
              <Route
                path="/entregas"
                element={
                  <PrivateRoute>
                    <Entregas />
                  </PrivateRoute>
                }
              />
              <Route
                path="/notifications"
                element={
                  <PrivateRoute>
                    <Notifications />
                  </PrivateRoute>
                }
              />
              <Route
                path="/nfe"
                element={
                  <PrivateRoute>
                    <NFe />
                  </PrivateRoute>
                }
              />
              <Route
                path="/employees"
                element={
                  <PrivateRoute>
                    <Employees />
                  </PrivateRoute>
                }
              />
              <Route
                path="/users"
                element={
                  <AdminRoute>
                    <Users />
                  </AdminRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <AdminRoute>
                    <Settings />
                  </AdminRoute>
                }
              />
              <Route
                path="/lembretes"
                element={
                  <PrivateRoute>
                    <Lembretes />
                  </PrivateRoute>
                }
              />
              <Route
                path="/simulador-cartao"
                element={
                  <PrivateRoute>
                    <SimuladorCartao />
                  </PrivateRoute>
                }
              />
              <Route path="/central/dashboard" element={<PrivateRoute><CentralDashboard /></PrivateRoute>} />
              <Route path="/central/conversas" element={<PrivateRoute><CentralConversas /></PrivateRoute>} />
              <Route path="/central/aguardando" element={<PrivateRoute><CentralAguardando /></PrivateRoute>} />
              <Route path="/central/base-conhecimento" element={<PrivateRoute><CentralBaseConhecimento /></PrivateRoute>} />
              <Route path="/central/config-ia" element={<PrivateRoute><CentralConfigIA /></PrivateRoute>} />
              <Route path="/central/config-whatsapp" element={<PrivateRoute><CentralConfigWhatsApp /></PrivateRoute>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              <Toaster position="top-right" richColors />
            </div>
          </ScreenLock>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;